import { useNavigate } from "react-router-dom";
import useAdminLoginRedirect from "./useAdminLoginRedirect";

const useErrorPage = () => {
    const navigate = useNavigate();
    const [toAdminLogin] = useAdminLoginRedirect();

    const toErrorPage = (error: any) => {
        // A blocked or failed request (CORS, network down) has no response, so it goes to the error page
        if(error.response?.status === 401) {
            localStorage.removeItem("admin");
            localStorage.removeItem("token");
            // An expired session returns the admin to the page they were on after logging in again
            toAdminLogin("Your session has expired. Please login again.");
        }
        else {
            navigate('/error', { state: { error: error.message }});
        }
    }

    return [toErrorPage];
};

export default useErrorPage;